import React from "react";
import { connect } from "react-redux";

import { getBasketItemGroupList } from "state/school_money/selectors";

import StudentName from "components/school_money/StudentName";
import BasketItemGroup from "components/school_money/basket/BasketItemGroup";

class StudentBasketItemList extends React.Component {
  
  render() {
    
    const { studentID, basketItemGroups } = this.props;
    
    return (
      <div className="student-basket-item-list">
        <div className="student-basket-item-list__header">
          <div className="student-basket-item-list__student-name">
            <StudentName studentID={studentID} />
          </div>
        </div>
        <div className="student-basket-item-list__body">
          {
            basketItemGroups.map((basketItemGroup, groupID) => (
              <BasketItemGroup key={groupID} basketItemGroup={basketItemGroup} />
            ))
          }
        </div>
      </div>
    )
    
  }
  
}

export default connect(
  (state, { studentID }) => ({
    basketItemGroups: getBasketItemGroupList(state, studentID)
  })
)(StudentBasketItemList);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/StudentBasketItemList.js